import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { httpss } from '../../utils/host';
import { GlobalState } from '../../store/GlobalState';
import logoMyH from '../../assets/images/logo-myH.png'
export default function ListPage() {

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [data, setData] = useState([]);
  const [fanpages, setFanpages] = useState([]);
  const [pageDetails, setPageDetails] = useState([]);
  const [selectedPageId, setSelectedPageId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(50);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(false);
  const accessToken = sessionStorage.getItem('accessToken');

  const fetPage = async (page = 1, limit = postsPerPage, pageId = selectedPageId) => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString()
      });
      if (pageId) {
        params.append('pageId', pageId);
      }
      const response = await axios.get(`${httpss}/apis_v1/admin/getDataPage?${params}`,
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${accessToken}` } });
      if (response.data.data) {
        setData(response.data.data);
        setPagination(response.data.pagination);
        if (!selectedPageId && response.data.data.length > 0) {
          setSelectedPageId(response.data.data[0].id.toString());
        }
      } else {
        setData(response.data);
        if (!selectedPageId && response.data.length > 0) {
          setSelectedPageId(response.data[0].id.toString());
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetPage();
  }, []);

  useEffect(() => {
    if (selectedPageId) {
      fetPage(currentPage, postsPerPage, selectedPageId);
    }
  }, [selectedPageId, currentPage, postsPerPage]);

  const handlePageSelect = (event) => {
    setSelectedPageId(event.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleLimitChange = (event) => {
    setPostsPerPage(parseInt(event.target.value));
    setCurrentPage(1);
  };

  const selectedPage = Array.isArray(data) && data.find((fanpage) => fanpage.id === parseInt(selectedPageId));

  useEffect(() => {
    // Load Facebook SDK
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: '1303634020222700', // replace with your Facebook app ID
        cookie: true,
        xfbml: true,
        version: 'v20.0',
      });
    };
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/vi_VN/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  }, []);

  const handleConnectFanpage = () => {
    window.FB.login(
      (response) => {
        if (response.authResponse) {
          setIsAuthenticated(true);
          fetchFanpages();
        }
      },
      { scope: 'pages_show_list,pages_read_engagement,pages_read_user_content' }
      // { scope: 'pages_show_list' }
    );
  };

  const fetchFanpages = () => {
    window.FB.api('/me/accounts', function (response) {
      if (response && !response.error) {
        const userAccessToken = window.FB.getAuthResponse()?.accessToken; // lấy user token
        setFanpages(response.data);
        
        response.data.forEach((page) => {
          fetchPageDetails(page, userAccessToken); // truyền vào
        });
      }
    });
  };
  

  const fetchPageDetails = (page, userAccessToken) => {
    const fetchPosts = (url) => {
      window.FB.api(
        url,
        { access_token: page.access_token },
        (response) => {
          if (response && !response.error) {
            const pageDetailsWithToken = {
              ...response,
              access_token: page.access_token,
              user_access_token: userAccessToken, // Gửi thêm về
              page_id: page.id,
            };
  
            setPageDetails((prevDetails) => {
              const updatedDetails = [...prevDetails, pageDetailsWithToken];
              savePageDetailsToDatabase(pageDetailsWithToken);
              return updatedDetails;
            });
  
            if (response.posts?.paging?.next) {
              fetchPosts(response.posts.paging.next);
            }
          } else {
            console.error("Error fetching page posts:", response.error);
          }
        }
      );
    };
  
    const url = `/${page.id}?fields=picture,name,posts{message,created_time,full_picture,permalink_url,reactions,comments,shares}`;
    fetchPosts(url);
  };
  
  

  const savePageDetailsToDatabase = async (pageDetails) => {
    await axios.post(`${httpss}/apis_v1/admin/savePageDetails`, pageDetails)
      .then(response => {
        console.log('Page details saved successfully:', response.data);
        fetPage()
      })
      .catch(error => {
        console.error('Error saving page details:', error);
      });
  };
  
  return (
    <div className="flex flex-col h-screen p-4 bg-gray-50">
      {/* Top Bar */}
      <div className="md:flex justify-between items-center gap-4 mb-4 bg-white rounded-lg shadow-md p-4">
        <div className="flex items-center gap-4">
          <select
            className="border rounded-lg px-4 py-2 shadow-sm outline-none"
            onChange={handlePageSelect}
            value={selectedPageId || ''}
          >
            <option value="" disabled>-- Choose a Fanpage --</option>
            {Array.isArray(data) && data.map((fanpage) => (
              <option key={fanpage.id} value={fanpage.id}>
                {fanpage.name}
              </option>
            ))}
          </select>
  
        </div>

    {selectedPage && (
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-4">
          <img
            src={selectedPage.picture}
            alt={selectedPage.name}
            className="w-10 h-10 rounded-full border shadow-sm object-cover"
          />
          <div>
            <p className="text-sm text-gray-500">ID: {selectedPage.FanPageId}</p>
            <p className="text-sm text-gray-500">Posts: {selectedPage?.PostFBs?.length || 0}</p>
          </div>
        </div>
        <div className="bg-red-500 text-white px-4 rounded-lg shadow-sm text-sm text-center">
          <p className="font-medium">⏰ Token expires:</p>
          <p>{new Date(selectedPage.user_token_expires_at).toLocaleString('vi-VN')}</p>
        </div>
      </div>
    )}
      </div>

      {/* Content Area */}
      <div className="flex-1 overflow-y-auto max-h-[80vh]">
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500"></div>
          </div>
        ) : selectedPage ? (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-1">
              {selectedPage.PostFBs.map((post) => (
                <div
                  key={post?.id}
                  className="flex flex-col justify-between p-1 border rounded-lg bg-white hover:bg-yellow-50 hover:shadow-md transition-all duration-200"
                >
                  <div className=' max-h-32 overflow-y-auto'>
                    {/* Header */}
                    <div className="flex justify-between text-xs text-gray-600 mb-1">
                      <a
                        href={post?.permalink_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:underline"
                      >
                        Xem bài viết
                      </a>
                      <p>{new Date(post?.updatedAt).toLocaleString('vi-VN')}</p>
                    </div>

                    {/* Message */}
                    <div className="text-sm text-gray-800 mb-1">
                      {post?.message?.length > 100
                        ? `${post?.message.slice(0, 100)}...`
                        : post?.message || 'No content available'}
                    </div>

                    {/* Image */}
                    <div className="mb-1">
                      <img
                        src={post?.full_picture || logoMyH}
                        alt={post?.message}
                        className="w-full max-h-[60px] object-cover rounded-lg"
                      />
                    </div>

                    {/* Reactions */}
                    <div className="flex justify-between text-xs text-gray-500 mb-1">
                      <p>👍 {post?.ReactionFBs.length} reactions</p>
                      <p>💬 {post?.CommentFBs.length} comments</p>
                    </div>

                  </div>

                  {/* Comments */}
                  {post?.CommentFBs.length > 0 ? (
                    <details className="pl-1">
                      <summary className="cursor-pointer text-xs text-gray-700 hover:underline py-1">
                        Xem thêm bình luận ({post?.CommentFBs.length})
                      </summary>
                      <ul className="pl-2 mt-2 list-disc space-y-2 max-h-32 overflow-y-auto pr-1">
                        {post?.CommentFBs.map((comment) => (
                          <li key={comment.id} className="text-xs text-gray-700 bg-gray-100 p-2 rounded-lg">
                            <p className="font-medium">{comment.name}</p>
                            <p>{comment.message || '(No comment)'}</p>
                          </li>
                        ))}
                      </ul>
                    </details>
                  ) : (
                    <div className="h-6" />
                  )}
                </div>
              ))}
            </div>

 
          </>
        ) : (
          <p className="text-sm text-gray-500 mt-4">Please select a fanpage to view details.</p>
        )}
      </div>
                  {/* Pagination Controls */}
            <div className='flex justify-between items-center'>
                      {pagination.totalPages > 1 && (
              <div className="flex justify-center items-center mt-2 gap-2">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={!pagination.hasPrevPage}
                  className="px-4 py-1 border rounded-lg bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  ← 
                </button>
                <span className="text-sm text-gray-500">
                  {currentPage} / {pagination.totalPages}
                </span>
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={!pagination.hasNextPage}
                  className="px-4 py-1 border rounded-lg bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                   →
                </button>
              </div>
            )}
        <select
            className="border rounded-lg px-4 py-1 shadow-sm outline-none"
            onChange={handleLimitChange}
            value={postsPerPage}
          >
            <option value={50}>50 posts/page</option>
            <option value={100}>100 posts/page</option>
            <option value={200}>200 posts/page</option>
          </select>
    
            </div>
    </div>
  );
}
